import { Verification } from "../../../services/verifyService/model";
import { CompositeSpecification } from "../../../utils/Specification";

export class RequiresMedicareAuth extends CompositeSpecification<Verification>{
    IsSatisfiedBy(candidate: Verification): boolean {
        let authRequired = false;
        
        // All Medicare codes requiring authorization
        const allMedicareAuthRequiredCodes = [
            // Hospital-only codes
            '15820','15821','15822','15823','67900','67901','67902','67903','67904','67906','67908',
            '64612','64615','J0585', 'J0586', 'J0587', 'J0588', '15830', '15847', '15877', '20912', '21210', 
            '30400', '30410', '30420', '30430', '30435', '30450', '30460', '30462', '30465', '30520', '36473', '36474',
            '36475', '36476', '36478', '36479', '36482', '36483', '22551','22552','63650','64490','64491','64492','64493',
            '64494','64495','64633','64634','64635','64636',
            // Hospital & ASC codes
            '22510','22511','22512',
            '22513','22514','22515',
            '22554',
            '62321','62323',
            '64479','64480',
            '64483','64484',
            '63655',
            '64568',
            '64561','64581',
            '33276','33277',
            '64582',
            // Neurostimulator / SCS codes (Medicare prior auth required)
            '63661','63662','63663','63664','63685','63688',
            '64553','64555','64566','64567','64569','64570',
            '64575','64580','64583','64584','64585','64590',
            '64595','64596','64597','64598',
            '64605','64610',
            '29877',
            '15271','15272','15273','15274','15275','15276','15277','15278'
        ];

        if (!candidate || !candidate.procedures || candidate.procedures.length === 0) {
            return false;
        }

        candidate.procedures.forEach(procedure => {
            // Check if procedure code requires Medicare authorization
            // Normalize code: trim whitespace for comparison
            const normalizedCode = procedure.code?.trim() || '';
            if (normalizedCode && allMedicareAuthRequiredCodes.includes(normalizedCode)) {
                authRequired = true;
            }
        });
        
        return authRequired;
    }
}